export const patchTipTapHTML = content => {
  if (content === null) return null;

  const parser = new DOMParser();
  const doc = parser.parseFromString(content, 'text/html');

  const listItems = doc.querySelectorAll('li');
  listItems.forEach(li => {
    const p = li.querySelector('p');
    if (p) {
      while (p.firstChild) {
        li.insertBefore(p.firstChild, p);
      }

      p.remove();
    }
  });

  return doc.body.innerHTML;
};
